<template>
  <div class="content">
    <div class="info-box" v-if="!isProcessed">
      <div class="info-item van-hairline--bottom" v-for="item in fields" :key="item.label">
        <div class="info-item-label">{{item.label}}</div>
        <div class="info-item-value">{{item.value}}</div>
      </div>
    </div>
    <div class="success-box" v-else>
      <van-icon name="passed" size="48" color="#FF6B31"/>
      <div class="tip1">核销成功</div>
      <div class="tip2">您可以点击下方按钮，继续核销</div>
    </div>
    <div class="btn-box">
      <template v-if="!isProcessed">
        <van-button block color="#FF6B31" @click="verify">立即核销</van-button>
        <van-button block plain  color="#FF6B31" @click="goBack">返回</van-button>
      </template>
      <template v-else>
        <van-button block color="#FF6B31" @click="continueVerify">继续核销</van-button>
        <van-button block plain  color="#FF6B31" @click="goHome">返回首页</van-button>
      </template>
    </div>
  </div>
</template>

<script>
import loadingMixin from '@/mixins/loading-mixin'
const md5 = require('md5');
import moment from 'moment'
import { 
  signupFields,
  groupFields,
  lotteryFields,
  spikeFields,
  drawLotsFields,
  countMoneyFields,
  couponFields
} from './config'
export default {
  name: 'VerifySignUp',
  mixins: [loadingMixin],
  data() {
    return {
      loading: null,
      // 是否已核销
      isProcessed: false,
      fields: signupFields,
      activityId: '',
      spikeParames: {},
      groupParames: {}
    }
  },
  computed: {
    type() {
      return this.$route.query.type
    },
    id() {
      return this.$route.query.id
    }
  },
  methods: {
    getVerificationData() {
      this.showLoading();
      this.$api.verification.getSignUpInfo(this.$route.query.itemId)
        .then(({data}) => {
          this.fields.forEach(item => {
            if (item.key === 'joinActivityAmount') {
              item.value = data[item.key] > 0
                ? `${data[item.key]}元`
                : '免费';
            } else if (item.key === 'signUpDate') {
              item.value = data[item.key]
                ? moment(data[item.key]).format('YYYY-MM-DD HH:mm:ss')
                : '';
            } else {
              item.value = data[item.key];
            }
          });
        })
        .finally(_ => {
          this.hideLoading();
        });
    },
    verify() {
      if (this.type == 3) {
        const {activityId, itemId} = this.$route.query;
        const params = {
          activityId,
          joinLogId: itemId,
          sign: md5(`activityId:${activityId},joinLogId:${itemId},s*Ua:&}~'@=$LF'cV1?e_=4B@~(+)u`)
        };

        this.showLoading();
        this.$api.verification.verifySign(params)
          .then((res) => {
            this.isProcessed = true;
          })
          .finally(err=> {
            this.hideLoading();
             
          }); 
      }else if (this.type == 4) {
        this.lotteryWriteOff()
      } else if (this.type == 5) {
        this.spikeWriteOff()
      } else if (this.type == 6) {
        this.groupWriteOff()
      } else if (this.type == 7) {
        this.drawLotsWriteOff()
      } else if (this.type == 8) {
        this.countMoneyWriteOff()
      } else if (this.type == 9) {
        this.couponWriteOff()
      }
      
    },
    getLotteryData() {
      this.$api.luckDraw.getLotteryData(this.id).then(({ data }) => {
        this.activityId = data.activityId
        this.fields.forEach(item => {
          if (item.key === 'prizeName') {
            item.value = data.winningType == 1 ? `${data.amount}元现金红包` : data.prizeName
          }else {
            item.value = data[item.key]
          }
        })
      })
    },
    // 获取秒杀信息
    getSpikeData() {
      this.$api.spike.getSeckillOrder(this.id).then( ({data}) => {
        const { h5UserId,orderNo }  = data
        this.spikeParames = {h5UserId,orderNo}
        this.activityId = data.activityId
        this.fields.forEach(item => {
          if (item.key === 'goodsPrice') {
            item.value =  data.goodsPrice ? `${data.goodsPrice }元` : '免费'
          }else {
            item.value = data[item.key]
          }
        })
      })
    },
    // 获取拼团信息
    getGroupData() {
      let statusMap = {0:'取消支付',1:'待支付',2:'已支付待核销',3:'已核销',4:'超时未支付过期',5:'客户已退款',6:'超时支付已退款',7:'退款中',8:'超时支付待退款'}
      this.$api.groupBuying.getGroupBuyingOrderInfo(this.id).then(({data}) => {
        const {activityId,orderNo} = data
        this.groupParames = {activityId,orderNo}
        this.fields.forEach(item => {
          if (item.key === 'goodsPrice') {
            item.value =  data.goodsPrice ? `${data.goodsPrice }元` : '免费'
          }else if (item.key === 'status') {
            item.value =  statusMap[data.status]
          }else {
            item.value = data[item.key]
          }
        })
      })
    },
    // 获取求签信息
    getDrawLots() {
      this.$api.drawlots.getExchangeRecordInfo(this.id).then(({data}) => {
        this.fields.forEach(item => {
          item.value = data[item.key]
        })
      })
    },
    // 获取红包挑战赛奖品信息
    getCountMoneyPrize() {
      this.$api.countMoney.getCountMoneyPrize(this.id).then(({data}) => {
         this.fields.forEach(item => {
          if (item.key === 'prizeType') {
            item.value = data[item.key] === 'award' ? '奖品' : '优惠券(线下)'
          } else {
            item.value = data[item.key]
          }
        })
      })
    },
    // 获取优惠券信息
    getCouponInfo() {
      this.$api.coupon.getCountMoneyPrize(this.id).then(({data}) => {
          this.fields.forEach(item => {
            item.value = data[item.key]
        })
      })
    },
    async lotteryWriteOff() {
      let params = {
        activityId: this.activityId,
        lotteryId: this.id,
        sign: md5(`activityId:${this.activityId},lotteryId:${this.id},s*Ua:&}~'@=$LF'cV1?e_=4B@~(+)u`)
      }
      this.showLoading()
      this.$api.luckDraw.lotteryVerification(params).then(res => {
        this.isProcessed = true;
      })
      .finally(err=> {
        this.hideLoading();
      
      });
    },
    spikeWriteOff() {
      const {orderNo} = this.spikeParames
      this.spikeParames.sign = md5(`orderNo:${orderNo},s*Ua:&}~'@=$LF'cV1?e_=4B@~(+)u`)
      this.showLoading()
      this.$api.verification.seckillVerification(this.spikeParames).then(res => {
        this.isProcessed = true;
      }).finally(err=> {
        this.hideLoading();
      });
    },
    groupWriteOff() {
      const {activityId,orderNo} = this.groupParames
      this.groupParames.sign = md5(`activityId:${activityId},orderNo:${orderNo},s*Ua:&}~'@=$LF'cV1?e_=4B@~(+)u`)
      this.showLoading()
      this.$api.groupBuying.groupBuyingVerification(this.groupParames).then(res =>{
        this.isProcessed = true;
      }).finally(err=> {
        this.hideLoading();
      });
    },
    drawLotsWriteOff() {
      let parames = {
        exchangeRecordId: this.id,
        sign: md5(`exchangeRecordId:${this.id},s*Ua:&}~'@=$LF'cV1?e_=4B@~(+)u`)
      }
      this.showLoading()
      this.$api.drawlots.exchangePrizeVerification(parames).then(res =>{
        this.isProcessed = true;
      }).finally(err=> {
        this.hideLoading();
      });
    },
    countMoneyWriteOff() {
       let parames = {
        exchangeRecordId: this.id,
        sign: md5(`exchangeRecordId:${this.id},s*Ua:&}~'@=$LF'cV1?e_=4B@~(+)u`)
      }
      this.showLoading()
      this.$api.countMoney.countMoneyPrizeWriteOff(parames).then(res => {
        this.isProcessed = true;
      }).finally(err=> {
        this.hideLoading();
      });
    },

    couponWriteOff() {
       let parames = {
        orderNo: this.id,
        sign: md5(`orderNo:${this.id},s*Ua:&}~'@=$LF'cV1?e_=4B@~(+)u`)
      }
      this.showLoading()
      this.$api.coupon.couponVerification(parames).then(res => {
        this.isProcessed = true;
      }).finally(err=> {
        this.hideLoading();
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    continueVerify() {
      this.$router.replace('/scan')
    },
    goHome() {
      this.$router.replace('/home')
    }
  },
  created() {
    // 报名核销
    if (this.type == 3) {
      this.getVerificationData();
    // 抽奖核销
    }else if (this.type == 4) {
      this.fields = lotteryFields
      this.getLotteryData()
    // 秒杀核销
    }else if (this.type == 5) {
      this.fields = spikeFields
      this.getSpikeData()
    // 拼团核销
    } else if (this.type == 6) {
      this.fields = groupFields
      this.getGroupData()
    // 求签核销
    } else if (this.type == 7) {
      this.fields = drawLotsFields
      this.getDrawLots()
      // 红包挑战赛核销
    } else if (this.type == 8) {
      this.fields = countMoneyFields
      this.getCountMoneyPrize()
      // 优惠券核销
    } else if (this.type == 9) {
      this.fields = couponFields
      this.getCouponInfo()
    }
  }
}
</script>

<style lang="stylus" scoped>
.content
  overflow-y auto
  .info-box
    margin 15px
    padding 0 15px
    border-radius 8px
    background-color: #fff
    .info-item
      padding 15px 0
      display: flex
      justify-content: space-between
      &-label
        color #999
        width 70px
        flex none
      &-value
        flex 1
        text-align: right
        color #333
  .success-box
    height 50vh
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    .tip1
      padding 15px 0
      font-size 18px
      color #333
    .tip2
      color #666
  .btn-box
    margin-top 50px
    padding 0 50px
    button
      border-radius 8px
    button+button
      margin-top 15px

</style>